// Textos de ponDetail (FE-03a, R06). Ligado em DICT.<lang>.app.ponDetail; lido por `useApp().t.app.ponDetail`.
// Página de detalhes de uma porta PON (cards SFP/óptico/frames, histórico, ONUs conectadas) e o modal
// "Configurar porta PON".

const pt = {
  locale: 'pt-BR',
  loading: 'Carregando...',
  notFound: 'Porta PON não encontrada',
  loadError: 'Não foi possível carregar a OLT',
  retry: 'Tentar de novo',
  backToOlts: 'Voltar às OLTs',
  back: 'Voltar',
  liveTrafficStop: 'Tráfego ao vivo · parar',
  liveTraffic: 'Tráfego ao vivo',
  configure: (port) => `Configurar porta PON ${port}`,
  refresh: 'Atualizar',
  title: 'Detalhes da PON',
  slotSep: ' · Slot ',
  portSep: ' · Porta ',
  enabled: 'Habilitado',
  disabled: 'Desabilitado',
  reading: 'Lendo da OLT…',
  unavailable: 'Não disponível',
  card: {
    general: 'Informações Gerais',
    olt: 'OLT:', slot: 'Slot:', pon: 'PON:', adminState: 'Estado admin:', description: 'Descrição:',
    sfpUnavailable: 'Não disponível (porta pode estar com o laser desligado, ou a leitura falhou)',
    class: 'Classe:', vendor: 'Fabricante:', productCode: 'Código do Produto:', serial: 'Número de Série:',
    optical: 'Módulo Óptico',
    tx: 'TX:', temperature: 'Temperatura:', voltage: 'Tensão:', current: 'Corrente:',
    received: 'Recebidos:', crc: 'CRC:', withError: 'Com Erro:', discarded: 'Descartados:',
    minRx: 'Menor RX:', maxRx: 'Maior RX:', rxDiff: 'Diferença de Rx:', avg: 'Média:',
    noOnuOnline: 'Nenhuma ONU online nesta porta',
    rxPonUnavailable: 'Não disponível (a leitura por porta não expõe Rx no OLT por ONU)',
  },
  history: {
    title: 'Histórico da porta PON ',
    points: (n) => `· ${n} pontos`,
    last24: 'últimas 24h',
    loading: 'Carregando métricas…',
    error: 'Falha ao carregar métricas',
    empty: 'Nenhuma métrica disponível ainda. Aguarde o próximo poll da OLT.',
    rxChart: 'RX Power médio (dBm)',
    rxSeries: 'RX (dBm)',
    onlineOffline: 'ONUs online / offline',
    online: 'Online',
    offline: 'Offline',
    traffic: 'Tráfego da porta (Mbps)',
    in: 'In',
    out: 'Out',
  },
  onus: {
    title: 'ONUs Conectadas ',
    liveOn: 'Ao vivo',
    liveOff: 'Indisponível',
    customer: 'Cliente', cto: 'CTO/Porta', onuId: 'ONU ID', sn: 'SN ONU', status: 'Status',
    lastSignal: 'Última atualização de sinal', txOnu: 'TX ONU', rxOnu: 'RX ONU', rxPon: 'RX PON',
    liveUp: 'Upload ao vivo', liveDown: 'Download ao vivo',
    loading: 'Carregando ONUs da porta…',
    empty: 'Nenhuma ONU nesta porta.',
    statusOnline: 'Online', statusNoPower: 'Sem Energia', statusLos: 'LOS',
  },
  liveError: 'Falha ao ler dados ópticos da OLT',
  toastConfigured: (port) => `Porta PON ${port} configurada`,
  toastConfigFailed: 'Falha ao configurar porta PON',
  modal: {
    adminA: 'Estado',
    adminB: 'administrativo',
    portDesc: 'Descrição da porta',
    rangeMin: 'Faixa Mínima',
    rangeMax: 'Faixa Máxima',
    meters: 'metros',
    close: 'Fechar',
    saving: 'Salvando…',
    save: 'Salvar',
  },
};

const en = {
  locale: 'en-US',
  loading: 'Loading...',
  notFound: 'PON port not found',
  loadError: 'Could not load the OLT',
  retry: 'Try again',
  backToOlts: 'Back to OLTs',
  back: 'Back',
  liveTrafficStop: 'Live traffic · stop',
  liveTraffic: 'Live traffic',
  configure: (port) => `Configure PON port ${port}`,
  refresh: 'Refresh',
  title: 'PON details',
  slotSep: ' · Slot ',
  portSep: ' · Port ',
  enabled: 'Enabled',
  disabled: 'Disabled',
  reading: 'Reading from the OLT…',
  unavailable: 'Not available',
  card: {
    general: 'General information',
    olt: 'OLT:', slot: 'Slot:', pon: 'PON:', adminState: 'Admin state:', description: 'Description:',
    sfpUnavailable: 'Not available (the port may have its laser off, or the read failed)',
    class: 'Class:', vendor: 'Vendor:', productCode: 'Product code:', serial: 'Serial number:',
    optical: 'Optical module',
    tx: 'TX:', temperature: 'Temperature:', voltage: 'Voltage:', current: 'Current:',
    received: 'Received:', crc: 'CRC:', withError: 'With error:', discarded: 'Discarded:',
    minRx: 'Lowest RX:', maxRx: 'Highest RX:', rxDiff: 'Rx difference:', avg: 'Average:',
    noOnuOnline: 'No ONU online on this port',
    rxPonUnavailable: 'Not available (the per-port read does not expose Rx on the OLT per ONU)',
  },
  history: {
    title: 'PON port history ',
    points: (n) => `· ${n} points`,
    last24: 'last 24h',
    loading: 'Loading metrics…',
    error: 'Failed to load metrics',
    empty: 'No metrics available yet. Wait for the next OLT poll.',
    rxChart: 'Average RX power (dBm)',
    rxSeries: 'RX (dBm)',
    onlineOffline: 'ONUs online / offline',
    online: 'Online',
    offline: 'Offline',
    traffic: 'Port traffic (Mbps)',
    in: 'In',
    out: 'Out',
  },
  onus: {
    title: 'Connected ONUs ',
    liveOn: 'Live',
    liveOff: 'Unavailable',
    customer: 'Customer', cto: 'CTO/Port', onuId: 'ONU ID', sn: 'ONU SN', status: 'Status',
    lastSignal: 'Last signal update', txOnu: 'ONU TX', rxOnu: 'ONU RX', rxPon: 'PON RX',
    liveUp: 'Live upload', liveDown: 'Live download',
    loading: 'Loading the port ONUs…',
    empty: 'No ONU on this port.',
    statusOnline: 'Online', statusNoPower: 'No power', statusLos: 'LOS',
  },
  liveError: 'Failed to read optical data from the OLT',
  toastConfigured: (port) => `PON port ${port} configured`,
  toastConfigFailed: 'Failed to configure PON port',
  modal: {
    adminA: 'Administrative',
    adminB: 'state',
    portDesc: 'Port description',
    rangeMin: 'Minimum range',
    rangeMax: 'Maximum range',
    meters: 'meters',
    close: 'Close',
    saving: 'Saving…',
    save: 'Save',
  },
};

const es = {
  locale: 'es-ES',
  loading: 'Cargando...',
  notFound: 'Puerto PON no encontrado',
  loadError: 'No se pudo cargar la OLT',
  retry: 'Reintentar',
  backToOlts: 'Volver a las OLTs',
  back: 'Volver',
  liveTrafficStop: 'Tráfico en vivo · detener',
  liveTraffic: 'Tráfico en vivo',
  configure: (port) => `Configurar puerto PON ${port}`,
  refresh: 'Actualizar',
  title: 'Detalles de la PON',
  slotSep: ' · Slot ',
  portSep: ' · Puerto ',
  enabled: 'Habilitado',
  disabled: 'Deshabilitado',
  reading: 'Leyendo de la OLT…',
  unavailable: 'No disponible',
  card: {
    general: 'Información general',
    olt: 'OLT:', slot: 'Slot:', pon: 'PON:', adminState: 'Estado admin:', description: 'Descripción:',
    sfpUnavailable: 'No disponible (el puerto puede tener el láser apagado, o la lectura falló)',
    class: 'Clase:', vendor: 'Fabricante:', productCode: 'Código del producto:', serial: 'Número de serie:',
    optical: 'Módulo óptico',
    tx: 'TX:', temperature: 'Temperatura:', voltage: 'Tensión:', current: 'Corriente:',
    received: 'Recibidos:', crc: 'CRC:', withError: 'Con error:', discarded: 'Descartados:',
    minRx: 'Menor RX:', maxRx: 'Mayor RX:', rxDiff: 'Diferencia de Rx:', avg: 'Promedio:',
    noOnuOnline: 'Ninguna ONU en línea en este puerto',
    rxPonUnavailable: 'No disponible (la lectura por puerto no expone Rx en la OLT por ONU)',
  },
  history: {
    title: 'Historial del puerto PON ',
    points: (n) => `· ${n} puntos`,
    last24: 'últimas 24h',
    loading: 'Cargando métricas…',
    error: 'Error al cargar las métricas',
    empty: 'Aún no hay métricas disponibles. Espere el próximo sondeo de la OLT.',
    rxChart: 'Potencia RX media (dBm)',
    rxSeries: 'RX (dBm)',
    onlineOffline: 'ONUs en línea / fuera de línea',
    online: 'En línea',
    offline: 'Fuera de línea',
    traffic: 'Tráfico del puerto (Mbps)',
    in: 'Entrada',
    out: 'Salida',
  },
  onus: {
    title: 'ONUs conectadas ',
    liveOn: 'En vivo',
    liveOff: 'No disponible',
    customer: 'Cliente', cto: 'CTO/Puerto', onuId: 'ONU ID', sn: 'SN ONU', status: 'Estado',
    lastSignal: 'Última actualización de señal', txOnu: 'TX ONU', rxOnu: 'RX ONU', rxPon: 'RX PON',
    liveUp: 'Subida en vivo', liveDown: 'Bajada en vivo',
    loading: 'Cargando las ONUs del puerto…',
    empty: 'Ninguna ONU en este puerto.',
    statusOnline: 'En línea', statusNoPower: 'Sin energía', statusLos: 'LOS',
  },
  liveError: 'Error al leer los datos ópticos de la OLT',
  toastConfigured: (port) => `Puerto PON ${port} configurado`,
  toastConfigFailed: 'Error al configurar el puerto PON',
  modal: {
    adminA: 'Estado',
    adminB: 'administrativo',
    portDesc: 'Descripción del puerto',
    rangeMin: 'Rango mínimo',
    rangeMax: 'Rango máximo',
    meters: 'metros',
    close: 'Cerrar',
    saving: 'Guardando…',
    save: 'Guardar',
  },
};

export const PON_DETAIL_I18N = { pt, en, es };
